import axios from "axios";
import localStorageService from "./localStorageService";

class JwtAuthService {
  async loginWithEmailAndPassword({ email, password }) {
    const response = await axios.post(
      `${process.env.REACT_APP_BASEURL}/user/login`,
      { email, password }
    );
    const data = response.data;
    if (!data?.success) throw new Error(data?.message || "Login failed");

    this.setSession(data.tokenExpiresAt);
    this.setUser({ user: data });
    return data;
  }

  async loginWithToken() {
    const user = localStorageService.getItem("auth_user");
    if (localStorage.getItem("sessionActive") !== "true" || !user) {
      throw new Error("No authenticated session");
    }
    return user;
  }

  async logout() {
    try {
      await axios.post(`${process.env.REACT_APP_BASEURL}/user/logout`, null, {
        withCredentials: true,
      });
    } finally {
      this.setSession(null);
    }
    this.removeUser();
  }

  setSession(tokenExpiresAt) {
    if (tokenExpiresAt) {
      localStorage.setItem("sessionActive", "true");
      if (tokenExpiresAt) {
        localStorage.setItem("tokenExpiresAt", tokenExpiresAt);
      } else {
        localStorage.removeItem("tokenExpiresAt");
      }
    } else {
      localStorage.removeItem("sessionActive");
      localStorage.removeItem("tokenExpiresAt");
      localStorage.removeItem("jwt_token");
    }
  }

  setUser(user) {
    localStorageService.setItem("auth_user", user);
  }

  removeUser() {
    localStorage.removeItem("auth_user");
  }
}

const service = new JwtAuthService();
export default service;
